import { render, staticRenderFns } from "./FormClientePublic.vue?vue&type=template&id=53cc73e0&"
import script from "./FormClientePublic.vue?vue&type=script&lang=js&"
export * from "./FormClientePublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports